import { render, staticRenderFns } from "./cExamRoom.vue?vue&type=template&id=20315c08&scoped=true&"
import script from "./cExamRoom.vue?vue&type=script&lang=js&"
export * from "./cExamRoom.vue?vue&type=script&lang=js&"
import style0 from "./cExamRoom.vue?vue&type=style&index=0&id=20315c08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20315c08",
  null
  
)

export default component.exports